import { render, staticRenderFns } from "./MoreOptions.vue?vue&type=template&id=508bf555"
import script from "./MoreOptions.vue?vue&type=script&lang=js"
export * from "./MoreOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports